import React, { FC } from 'react';
import { UserRoute } from '../../components';
import { useConvention } from '../../utils';
import { MyReservation } from './MyReservation';
import { WaveInfo } from './WaveInfo';
import { HotelDashboard } from './dashboard';

export const HotelRouteHandler: FC = () => {
  const { hotelsEnabled } = useConvention();

  if (!hotelsEnabled) {
    return null;
  }

  return (
    <>
      <UserRoute component={HotelDashboard} exact path="/hotel" />
      <UserRoute component={WaveInfo} exact path="/hotel/wave/:id" />
      <UserRoute component={MyReservation} exact path="/hotel/reservation/:id" />
    </>
  );
};
